import { handleHomeEquityInquirySubmit } from 'app/actions/form/actions';
import { FieldNames } from 'app/models/fields/names';
import { FormParagraphs } from 'app/models/paragraphs';
import { homeEquityInquiryQuestionById, homeEquityInquiryQuestionsByName } from 'app/models/questions/home-equity-inquiry';
import { Section } from 'app/models/types';
import {
  HOME_EQUITY_INQUIRY_CONFIRMATION,
  HOME_EQUITY_INQUIRY_FINAL_PAGE_QUESTION,
  HOME_EQUITY_INQUIRY_LOAN_AMOUNT,
  HOME_EQUITY_INQUIRY_LOAN_PURPOSE,
  HOME_EQUITY_INQUIRY_PERSONAL_INFORMATION,
  HOME_EQUITY_INQUIRY_PROPERTY_ADDRESS,
  HOME_EQUITY_INQUIRY_PROPERTY_INFORMATION,
} from './constants';

export const getHomeEquityInquirySectionById = (id: number): Section => {
  return HOME_EQUITY_INQUIRY_SECTIONS.find((section) => section.id === id) as Section;
};

const HOME_EQUITY_INQUIRY_SECTIONS: Section[] = [
  {
    id       : HOME_EQUITY_INQUIRY_PROPERTY_INFORMATION,
    title    : 'Please provide your home information',
    paragraph: FormParagraphs.homeEquityBorrow,
    questions: homeEquityInquiryQuestionsByName([
      FieldNames.homeValue,
      FieldNames.mortgageBalance,
      FieldNames.propertyType,
      FieldNames.propertyUsage,
    ]),
    hideBackButton : true,
    hideProgressBar: true,
  },
  {
    id       : HOME_EQUITY_INQUIRY_PROPERTY_ADDRESS,
    title    : 'Where is the property you will use as collateral?',
    questions: homeEquityInquiryQuestionsByName([
      FieldNames.propertyStreet,
      FieldNames.propertyStreet2,
      FieldNames.propertyCity,
      FieldNames.propertyState,
      FieldNames.propertyZip,
    ]),
    hideProgressBar: true,
  },
  {
    id       : HOME_EQUITY_INQUIRY_LOAN_PURPOSE,
    questions: homeEquityInquiryQuestionsByName([
      FieldNames.homeEquityLoanPurpose,
      FieldNames.homeEquityLoanPurposeOther,
    ]),
    hideProgressBar: true,
  },
  {
    id       : HOME_EQUITY_INQUIRY_LOAN_AMOUNT,
    questions: homeEquityInquiryQuestionsByName([
      FieldNames.loanAmount,
    ]),
    hideProgressBar: true,
  },
  {
    id       : HOME_EQUITY_INQUIRY_PERSONAL_INFORMATION,
    title    : 'Enter your personal information',
    questions: homeEquityInquiryQuestionsByName([
      FieldNames.firstName,
      FieldNames.middleName,
      FieldNames.lastName,
      FieldNames.suffixName,
      FieldNames.email,
      FieldNames.phone,
      FieldNames.dateOfBirth,
    ]),
    hideProgressBar: true,
    submitText     : 'Submit',
    submitAction   : handleHomeEquityInquirySubmit,
  },
  {
    id                : HOME_EQUITY_INQUIRY_CONFIRMATION,
    questions         : [homeEquityInquiryQuestionById(HOME_EQUITY_INQUIRY_FINAL_PAGE_QUESTION)],
    hideBackButton    : true,
    hideForwardButton : true,
    hideProgressBar   : true,
  },
];
